// ============================================================================
// Entity: ContactCodes
// Key: contactCodes
// Kind: entity
// Generated file. Do not edit manually.
// ============================================================================

import {
	contactCodesCreate,
	getContactCodesListQueryKey,
	getContactCodesListQueryOptions,
} from '../api/backstage'
// #region Imports
import type {
	ContactCodeResponse,
	CreateOrUpdateContactCodeRequest,
	PagedResultOfContactCodeResponse,
} from '../api/backstage.schemas'
import type { EntityConfig, ListQueryParams } from './entity-config.types'
import {
	defineMutationEndpoint,
	defineQueryEndpoint,
} from './entity-config.types'

// #endregion

// #region Entity Endpoints
const contactCodesEntityEndpoints = {
	create: defineMutationEndpoint<
		ContactCodeResponse,
		CreateOrUpdateContactCodeRequest,
		undefined
	>({
		key: 'contactCodes.create',
		method: 'POST',
		path: '/admin/contactcodes',
		mutationOptions: () => ({
			mutationFn: (variables: { data: CreateOrUpdateContactCodeRequest }) =>
				contactCodesCreate(variables.data),
		}),
		invalidates: [(_context) => getContactCodesListQueryKey()],
	}),
	list: defineQueryEndpoint<
		PagedResultOfContactCodeResponse,
		undefined,
		ListQueryParams
	>({
		key: 'contactCodes.list',
		method: 'GET',
		path: '/admin/contactcodes',
		queryKey: (args) => getContactCodesListQueryKey(args?.queryParams),
		queryOptions: (args) => getContactCodesListQueryOptions(args?.queryParams),
	}),
} as const
// #endregion

// #region Entity Config Export
export const contactCodesEntityConfig = {
	key: 'contactCodes',
	kind: 'entity',
	entity: {
		idField: 'id',
		routePath: '/contactCodes',
	},
	endpoints: contactCodesEntityEndpoints,
} as const satisfies EntityConfig<'contactCodes'>
// #endregion
